import React,{ useState, useEffect, useContext } from 'react';
import { Outlet, NavLink, useLoaderData } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';
import useWindowSize from './hooks/useGatsbyWindowSize';
import useBodyPathClasses from './hooks/useBodyPathClasses';
/* import AnimatedCursor from "react-animated-cursor"; */

import {
  CookieConsentProvider,
  CookieBanner,
  FloatingConsentInfo,
  CookieService
} from "@vantezzen/react-cookie-banner";


import Navbar from "./component/Navbar";
import Footer from "./component/Footer";


import { ThemeContext } from './context/ThemeContext';
import './index.css';

function App() {

 useBodyPathClasses();

let social = useLoaderData();

const {width,height} = useWindowSize();
const vertical = useMediaQuery({ query: `(orientation: portrait)` }); //detecting orientation vs max-width: 821px;

const theme = useContext(ThemeContext);



  useEffect(()=> {
    //console.log(width,height);
    theme.dispatch({pushOut:false, width:width, height:height, vertical:vertical,type: 'viewport' });

  },[width,height,vertical])

  useEffect(()=> {
  var touchRegionElement = document.getElementById('app');
  /*  var _cursor_ = touchRegionElement.getElementsByTagName('div')[0]; */

/*  function showCoordinates(e) {
     _cursor_.style.left = `${e.touches[0].clientX}`;
     _cursor_.style.top = `${e.touches[0].clientY}`;
  }*/

/*
  touchRegionElement.addEventListener('touchstart', showCoordinates);
  touchRegionElement.addEventListener('touchend', showCoordinates);
  touchRegionElement.addEventListener('touchmove', showCoordinates);
  */

  },[width])

  return (

    <div id="app">
  {/*  <AnimatedCursor
    className="cs"
    data-cursor="1"
    showSystemCursor={true}
    trailingSpeed={12}
    innerSize={18}
      outerSize={8}
      color='255, 255, 255'
      outerAlpha={0.1}
      innerScale={0.7}
      outerScale={2}
      outerSize={25}
      outerStyle={{
        boxShadow:'0 0 3px #fff, -3px 0 8px #f0f, 3px 0 8px #0ff'
  }}
  innerStyle={{
    backgroundColor: 'transparent'
  }}
      hasBlendMode={true}
      clickables={[
        'a',
        'input[type="text"]',
        'input[type="email"]',
        'input[type="number"]',
        'input[type="submit"]',
        'input[type="image"]',
        'label[for]',
        'select',
        'textarea',
        'button',
        '.link'
      ]}
  />*/}
   <Navbar  social={social}/>
{/* #c5d24c */}
   <div id="main" style={{minHeight:100+'vh',width:'100%'}} className="bg-zinc-900 relative">
     <div style={{zIndex:99999}} className=" absolute left-3 md:left-1 lg:left-2 top-3 md:top-4 pl-4 md:pl-8">
       <a href="/" aria-label="home" className="">
         <svg className="brandLogo" width="140"
         xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 300 100"
         fill="currentColor">
         <path className="st0" d="M125.89,31.17l7.55-21.99-61.26.21v48.5L55.41,9.07h-26.13L1.59,89.63h25.79l3.32-11.46h22.7l3.44,11.46h40.1v-27.74h18.4l6.96-20.28-25.36.1v-10.55h28.94ZM48.14,59.82h-12.04l5.96-20.86h0s0,0,0,0l6.08,20.86h0Z"/>
  <g>
    <path className="st0" d="M117.37,62.57h9.35c6.06,0,10.19,3.09,10.19,9.55v.23c0,6.69-4.55,9.79-10.12,9.79h-1.89v7.5h-7.53v-27.08ZM126.41,75.84c1.79,0,3.05-1.04,3.05-3.13v-.15c0-2.13-1.16-3.17-3.01-3.17h-1.54v6.46h1.51Z"/>
    <path className="st0" d="M141.89,62.57h7.57v27.08h-7.57v-27.08Z"/>
    <path className="st0" d="M154.88,76.49v-.66c0-8.43,5.25-13.81,11.67-13.81,4.17,0,7.08,2.01,9.04,5.11l-5.12,5.18c-.77-1.35-1.89-2.55-3.78-2.55-2.38,0-4.1,2.24-4.1,6.23v.15c0,4.29,1.86,6.31,4.13,6.31,1.96,0,3.08-1.24,3.89-2.63l5.12,4.99c-1.79,2.9-4.69,5.38-9.46,5.38-6.13,0-11.39-5.11-11.39-13.69Z"/>
    <path className="st0" d="M185.6,69.88h-5.99v-7.31h19.55v7.31h-5.99v19.77h-7.57v-19.77Z"/>
    <path className="st0" d="M204.03,78.74v-16.17h7.67v16.25c0,2.71,1.23,3.91,2.94,3.91s2.94-1.12,2.94-3.79v-16.36h7.64v16.01c0,8.28-4.31,11.6-10.65,11.6s-10.55-3.37-10.55-11.45Z"/>
    <path className="st0" d="M230.89,62.57h10.09c3.78,0,6.41,1.04,8.06,2.86,1.44,1.59,2.21,3.64,2.21,6.46v.23c0,3.91-1.68,6.42-4.2,7.93l4.91,9.59h-8.48l-3.82-7.89h-1.23v7.89h-7.53v-27.08ZM240.88,75.6c1.68,0,2.77-1.01,2.77-2.9v-.19c0-1.93-1.09-2.9-2.73-2.9h-2.49v6h2.45Z"/>
    <path className="st0" d="M256.39,62.57h17.97v7.12h-10.48v3.09h9.71v6.5h-9.71v3.25h10.65v7.12h-18.15v-27.08Z"/>
    <path className="st0" d="M278.18,86.13l3.64-6c2.35,1.97,4.97,3.02,7.29,3.02,1.37,0,1.89-.54,1.89-1.28v-.08c0-.81-.74-1.28-2.98-2.01-4.91-1.62-8.69-3.52-8.69-8.7v-.15c0-5.11,3.5-8.82,9.42-8.82,3.71,0,6.8.93,9.6,3.33l-3.54,6.07c-1.79-1.43-4.1-2.44-6.17-2.44-1.12,0-1.68.54-1.68,1.2v.08c0,.81.74,1.28,3.15,2.13,5.01,1.51,8.55,3.64,8.55,8.63v.12c0,5.45-3.85,8.9-9.63,8.9-4.13,0-7.88-1.28-10.86-3.98Z"/>
  </g>

         </svg>
       </a>
     </div>
     <Outlet/>
</div>


<Footer/>

<CookieConsentProvider>
      <CookieBanner
        id="ckb"
        lang={{
    title: "Uso de las Cookies",
    description:
      'Utilizamos cookies para mejorar su experiencia de navegación. Al hacer clic en "Aceptar", consiente nuestro uso de cookies.',
    required: "Requiridas",

    privacyPolicyInfo: "para más información vista nuestra",
    privacyPolicy: "politica de cookie",
    privacyPolicyUrl: "/privacy",
    acceptAll: "Aceptar",
    saveSelection: "Guardar",
    disableAll: "Denegar",

    essential: "esenciales",
    marketing: "Marketing",
    analytics: "Analiticas",
    other: "Otras",
  }}
    />
      <FloatingConsentInfo />
      <CookieService>
        {/* External scripts/components go here */}

      </CookieService>
    </CookieConsentProvider>

</div>


  );
}

export default App;
